document.addEventListener('DOMContentLoaded', function () {
  const openBtn = document.getElementById('montage-service-btn');
  const modal = document.getElementById('montage-modal');
  if (!openBtn || !modal) return;

  const closeBtn = modal.querySelector('.montage-modal__close');
  const overlay = modal.querySelector('.montage-modal__overlay');
  const form = document.getElementById('montage-form');

  openBtn.addEventListener('click', () => modal.style.display = 'block');
  closeBtn.addEventListener('click', () => modal.style.display = 'none');
  overlay.addEventListener('click', () => modal.style.display = 'none');

  form.addEventListener('submit', async function (e) {
    e.preventDefault();
    const submitBtn = form.querySelector('.montage-form__submit-btn');
    submitBtn.disabled = true;
    submitBtn.textContent = 'Wird gesendet…';

    const fd = new FormData(form);

    // Zusatzarbeiten als kommagetrennte Liste einsammeln
    const zusatzarbeiten = [];
    if (fd.get('zusatz_fundament')) {
      let entry = 'Fundament erstellen';
      if (fd.get('fundament_art')) entry += ` (${fd.get('fundament_art')})`;
      zusatzarbeiten.push(entry);
    }
    if (fd.get('zusatz_streichen')) zusatzarbeiten.push('Artikel streichen');
    if (fd.get('zusatz_entsorgung')) zusatzarbeiten.push('Entsorgung Palette');
    if (fd.get('zusatz_sonstiges')) zusatzarbeiten.push(fd.get('zusatz_sonstiges'));
    fd.set('zusatzarbeiten_zusammengefasst', zusatzarbeiten.join(', ') || '—');

    try {
      const res = await fetch('https://montage.sanilu.ch/api/montage-anfrage', {
        method: 'POST',
        body: fd
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || 'Fehler beim Senden');
      }

      // Erfolg: Formular ausblenden, Bestätigung zeigen
      form.style.display = 'none';
      const successMsg = document.createElement('p');
      successMsg.className = 'montage-form__success';
      successMsg.textContent = 'Ihre Anfrage wurde erfolgreich versendet.';
      form.parentNode.appendChild(successMsg);

      // Modal nach kurzer Anzeige automatisch schließen
      setTimeout(() => {
        modal.style.display = 'none';
        form.reset();
        form.style.display = 'block';
        successMsg.remove();
      }, 2500);

    } catch (err) {
      alert('Es gab ein Problem: ' + err.message);
      submitBtn.disabled = false;
      submitBtn.textContent = 'Anfrage senden';
    }
  });
});